<template>
  <!-- <div> -->
  <!-- <form v-if="form" class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">LOGOWANIE</h5>
        </div>
        <div class="modal-body">
          <div v-if="form" class="form-group">
            <input
              id="email"
              name="email"
              class="form-control"
              type="email"
              required
              v-model="form.email.value"
              placeholder="Login:"
              @blur="validateField($event, form.email)"
            />
            <span class="invalid-feedback" v-if="form.email.errors.required"
              >Email nie może być pusty</span
            >
            <span class="invalid-feedback" v-if="form.email.errors.custom"
              >Nieprawidłowy login lub hasło</span
            >
          </div>

          <div v-if="form" class="form-group">
            <input
              id="password"
              class="form-control"
              type="password"
              name="password"
              required
              v-model="form.password.value"
              @blur="validateField($event, form.password)"
              placeholder="Hasło:"
            />
            <span class="invalid-feedback" v-if="form.password.errors.required"
              >Hasło nie może być puste</span
            >
          </div>
        </div>
        <div v-if="!submitted" class="modal-footer">
          <div class="sign-in_button">
            <button
              class="btn btn-primary"
              :disabled="!submittable"
              @click="submit"
              right
            >
              ZALOGUJ SIĘ
            </button>
          </div>
          <div class="restore-link">
            <router-link :to="{ name: 'userRestorePassword' }"
              >Przypomnij hasło</router-link
            >
          </div>
        </div>
      </div>
  </form>-->

  <form v-if="form" class="sign-in-form">
    <div class="form-body">
      <div v-if="form" class="form-group">
        <input
          id="email"
          name="email"
          class="form-input form-control"
          type="email"
          required
          v-model="form.email.value"
          placeholder="Login:"
          @blur="validateField($event, form.email)"
        />
        <span
          class="text-danger d-inline invalid-input"
          v-if="form.email.errors.required"
        >Email nie może być pusty</span>
        <span
          class="text-danger d-inline invalid-input"
          v-if="form.email.errors.custom"
        >Nieprawidłowy login lub hasło</span>
      </div>

      <div v-if="form" class="form-group">
        <input
          id="password"
          class="form-input form-control"
          type="password"
          name="password"
          required
          v-model="form.password.value"
          @blur="validateField($event, form.password)"
          placeholder="Hasło:"
        />
        <span
          class="text-danger d-inline invalid-input"
          v-if="form.password.errors.required"
        >Hasło nie może być puste</span>
      </div>
    </div>
    <div v-if="!submitted" class="form-footer">
      <div class="form-button">
        <button class="btn btn-info" :disabled="!submittable" @click="submit" right>ZALOGUJ</button>
      </div>
      <div class="form-restore-link">
        <router-link :to="{ name: 'userRestorePassword' }">Przypomnij hasło</router-link>
      </div>
    </div>
  </form>
  <!-- </div> -->
</template>

<script type="text/babel">
import Form from "./../../form/src/Form";

export default {
  data() {
    return {
      form: Form.build({ email: "", password: "" }),
      submitted: false,
      progress: false
    };
  },
  computed: {
    submittable() {
      return !this.progress && !this.submitted;
    }
  },
  methods: {
    ...Form.methods(),

    async submit(evt) {
      let user = this.validateForm(evt, this.form);
      if (user) {
        try {
          this.progress = true;
          this.submitted = true;
          await this.$store.dispatch("user/signin", user);
          this.$noty.success("Zalogowano pomyślnie!");
          this.progress = false;
          this.submitted = false;
          this.$router.replace({ name: "welcomePage" });
        } catch (e) {
          this.setCustomError(this.form.email);
          this.progress = false;
          this.submitted = false;
          console.log(e);
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/user/src/SignPage.vue